
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormLabel',
    components: {
      Field,
      ErrorMessage,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      let currentItem: any = props.item;
      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,
      });


      onMounted(() => {


      });


      return {
        ...toRefs(state),
        i18n,
        helpers,
      };
    },
  });
